import React, { useContext, useEffect, useState } from "react";
import { UserData } from "../contexts/UserInfoContext";
import Loading from "../components/shared/Loading";
import { Navigate, Outlet } from "react-router-dom";
import { getItemStorage } from "../Localstorage/useLocalStorage";
import { getData } from "../services/API";
import { AccessDataContext } from "../contexts/AccessContext";

const AdminRoutes = () => {
  const { user, setUser, userLoaded } = useContext(UserData);
  const [loading, setLoading] = useState(true);
  const [run, setRun] = useState(true);
  const { access, setAccess } = useContext(AccessDataContext);


  const [isAuth, setIsAuth] = useState(null);

  const token = getItemStorage("token");

  const getAccesses = () => {
    setRun(false);

    getData("/uac/get-user-uac", {})
      .then((res) => {
        setAccess(res.data);
        setLoading(false);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (token) {
      if (userLoaded) {
        if (user.user?.id && user.user?.role === 2) {
          setIsAuth(true);

          run && getAccesses();
        } else {
          setIsAuth(false);
          setLoading(false);
        }
      }
    } else {
      setIsAuth(false);
      setLoading(false);
    }
  }, [token, isAuth, user, userLoaded]);

  if (isAuth !== null && !loading) {
    if (isAuth) {
      return <Outlet context={{ access, loading }} />;
    } else if (!isAuth && user?.user?.role === 1) {
      return <Navigate to="/user" />;
    } else {
      return <Navigate to="/auth" />;
    }
  } else {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Loading />
      </div>
    );
  }
};

export default AdminRoutes;
